import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { EmployeesGroupsContainer } from 'src/features/employees-groups/containers/employees-groups';
import { meilisearchSearchSchema } from 'src/hooks/meilisearch/schema/meilisearch-search-schema';

export const Route = createFileRoute(
  '/_layout/tenant/employees/_layout/groups',
)({
  component: EmployeesGroupsContainer,
  validateSearch: zodValidator(meilisearchSearchSchema),
});
